import React from 'react'
import Icon from '../Icon/Icon'
import './NoAvatar.sass'

function NoAvatar() {
  return (
    <div className="NoAvatar">
      <Icon name="heart-broken" />
    </div>
  )
}

export default NoAvatar
